export { default as KbSuggestedArticles } from './kb-suggestions';
export { KbArticle } from './styled';
